import React from "react";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export type MicroserviceActionsDropdownItemProps = {
    icon: IconProp
    onClick?: () => void | null
    text: string
};

export const MicroserviceActionsDropdownItem = ({ icon, onClick, text } : Readonly<MicroserviceActionsDropdownItemProps>) => (
    <Dropdown.Item onClick={onClick}>
        <FontAwesomeIcon icon={icon} size="sm" /> <span className="ms-1">{text}</span>
    </Dropdown.Item>
);

export default MicroserviceActionsDropdownItem;